<template>
  <div :title="weatherInfo.city + '，' + weatherInfo.weatherText + '，' + weatherInfo.temperature+'°C'">
    <img style="width: 100%;height: 100%" :src="require('@/assets/weather/'+fileName+'.svg')" alt="天气"/>
  </div>
</template>

<script>
import {getByLocationApi} from "@/api/weather";
import weatherIcon from "@/utils/weather-icon-compare";

export default {
  name: "cpt-weather",
  props: {
    option: Object, current: Object
  },
  watch: {
    'option.attribute.refreshFlag': {
      handler() {
        this.refreshWeather()
      },
    },
    'option.attribute.cityName': {
      handler() {
        this.refreshWeather()
      },
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshWeather();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshWeather();
      }
    },
  },
  data(){
    return {
      fileName:'晴',
      weatherInfo:{
        city:'',
        weatherText:'',
        temperature:24
      }
    }
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  created() {
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshWeather();
    }
  },
  methods:{
    refreshWeather(){
      const cityName = this.option.attribute.cityName ? this.option.attribute.cityName:'ip'
      let param = {location:cityName}
      if(this.option.attribute.apiKey){
        param.key = this.option.attribute.apiKey
      }
      getByLocationApi(param).then(res => {
        const info = res.data.results && res.data.results[0];
        this.weatherInfo.city = info.location.name
        this.weatherInfo.weatherText = info.now.text
        this.weatherInfo.temperature = info.now.temperature
        this.fileName = weatherIcon[info.now.code]
      })
    }
  }
}
</script>

<style scoped>

</style>